import type React from "react";
import { useAuth } from "./AuthContext";
import { Spinner } from "./Spinner";

interface AuthGuardProps {
	children: React.ReactNode;
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
	const { isAuthenticated, isLoading } = useAuth();

	if (isLoading) {
		return (
			<div
				style={{
					display: "flex",
					height: "100vh",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<Spinner size="large" />
			</div>
		);
	}

	if (!isAuthenticated) {
		return (
			<div
				style={{
					display: "flex",
					height: "100vh",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					gap: "1rem",
				}}
			>
				<h1 style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
					Access Restricted
				</h1>
				<p style={{ color: "var(--color-text-muted)" }}>
					This workspace is private.
				</p>
				<p style={{ fontSize: "0.875rem" }}>
					Use the secret entrance to authenticate.
				</p>
			</div>
		);
	}

	return <>{children}</>;
};
